import angular from "angular";

import AdminAppMarketplaceModuleRouting from "./app-marketplace.module.routing";

export default angular
    .module("vt-admin-application-marketplace", [])
    .config(AdminAppMarketplaceModuleRouting);
